var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"figure"},[_c('figcaption',{staticClass:"figure__title"},[_vm._v(_vm._s(_vm.chartConfig.options.title.text))]),_c('canvas',{staticClass:"figure__chart",attrs:{"id":_vm.chartId}})])}
var staticRenderFns = []

export { render, staticRenderFns }